export const EMAIL = "mail@msl-flinte.de";


// WEBPACK FOOTER //
// ./src/config/Config.ts